import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ProgressSpinner } from "primereact/progressspinner";
import { getReadyGarmentToSendToStore } from "../../services/warehouse/WarehouseProcess";

import addItemSound from '../../assets/sounds/warehousesound3.mp3';
const WarehouseOrderProcess = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { qrCode } = location.state || {}; // Fallback to prevent undefined errors

  const { warehouseData, brandProfileData } = getUserData();

  let warehouseId = warehouseData.id;
  let enabledRfIdModal = brandProfileData.enabledRfIdModal;

  const audioRef = useRef(new Audio(addItemSound));
  const handleAddItem = () => {
    const audio = audioRef.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState(null);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [changeScannerMethod, setChangeScannerMethod] = useState(false);
  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseValue, setWarehouseValue] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [isSendButtonPressedType, setIsSendButtonPressedType] = useState("");
  const [loading, setLoading] = useState(true);
  const [searchMethod, setSearchMethod] = useState(true);
  const [qrMethod, setQrMethod] = useState(false);
  const [rfidMethod, setRfidMethod] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [changeQrMethod, setChangeQrMethod] = useState(false);
  const [searchTermFocus, setSearchTermFocus] = useState("");
  const inputRef = useRef(null);

  const [dataProvider, setDataProvider] = useState([]);

  const [dataProviderSuggestion, setDataProviderSuggestion] = useState([]);

  let qrCodeMap = new Map();
  const fetchData = data => {
    data.forEach(element => {
      let garmentInfo = {
        garmentName: element.garmentName,
        garmentPack: element?.garmentPack || "",
        storeCode: element.storeCode,
        id: element.id,
        rfid: element.rfid,
      };
      qrCodeMap.set(element.qrCode, garmentInfo);
    });
    setQrCodes(qrCodeMap);
    setLoading(false);
  };


  useEffect(() => {
    fetchData(qrCode);
  }, [qrCode]);

  // const handleScan = ({ data }) => {
  //   if (data) {
  //     // Ensure data exists
  //     if (qrCodes.has(data) && !selectedQrCodesChecked.includes(data)) {
  //       let scannedData = {
  //           garmentName: qrCodes.get(data).garmentName,
  //         id: qrCodes.get(data).id,
  //         qrCode: data,
  //       };
  //       setSelectedQrCodes([...selectedQrCodes, scannedData]);
  //       setDataProvider([...selectedQrCodes, scannedData]);
  //       setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
  //     } else {
  //       
  //     }
  //   } else {
  //     console.error("Scanned QR data is null or undefined");
  //   }
  // };

  const handleClearSearch = () => {
    setSearchTermFocus("");
    setAlreadyPresentData("");
  };

  const [alreadyPresentData, setAlreadyPresentData] = useState("");

  const refocusInput = () => {
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus(); // Refocus the input
      }
    }, 10); // Add slight delay to ensure it focuses after processing
  };

  const handleScan = ({ data }) => {
    if (data) {
      setAlreadyPresentData("");
      // Ensure data exists
      if (qrCodes.has(data)) {
        setSearchTermFocus("");
        if (!selectedQrCodesChecked.includes(data)) {
          let scannedData = {
            garmentName: qrCodes.get(data).garmentName,
            garmentPack: qrCodes.get(data)?.garmentPack || "",
            storeCode: qrCodes.get(data).storeCode,
            id: qrCodes.get(data).id,
            rfid: qrCodes.get(data).rfid,
            qrCode: data,
          };
        setSelectedQrCodes([...selectedQrCodes, scannedData]);
        setDataProvider([...selectedQrCodes, scannedData]);
        handleAddItem()
        setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        } else {
          setAlreadyPresentData(`Tag ${data} is already exists.`);
          refocusInput(); // Refocus input
          setSearchTermFocus("");
        }
      }
    } else {
      console.error("Scanned QR data is null or undefined");
      refocusInput(); // Refocus input
      setSearchTermFocus("");
    }
  };

   const handleScanRFID = ({ data }) => {
     if (data) {
       setAlreadyPresentData("");

       // Check if RFID is already scanned before doing anything
       if (selectedQrCodesChecked.includes(data)) {
         setAlreadyPresentData(`Tag ${data} already exists.`);
         refocusInput();
         setSearchTermFocus("");
         return; // Stop further processing
       }

       // Find the entry in the map where the RFID matches the scanned value
       const garmentEntry = [...qrCodes.entries()].find(
         ([_, value]) => value.rfid === data
       );

       if (garmentEntry) {
         const [qrCode, garmentInfo] = garmentEntry;

         // Check if it’s already selected
         if (!selectedQrCodesChecked.includes(qrCode)) {
           let scannedData = {
             garmentName: garmentInfo.garmentName,
             garmentPack: garmentInfo?.garmentPack || "",
             storeCode: garmentInfo.storeCode,
             id: garmentInfo.id,
             rfid: garmentInfo.rfid,
             qrCode,
           };
           setSelectedQrCodes([...selectedQrCodes, scannedData]);
           setDataProvider([...selectedQrCodes, scannedData]);
           handleAddItem();
           setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
           refocusInput(); // Refocus input
           setSearchTermFocus("");
         } else {
           setAlreadyPresentData(`Tag ${data} is already exists.`);
           refocusInput(); // Refocus input
           setSearchTermFocus("");
         }
       } else {
         console.warn(`Scanned RFID ${data} not found in QR code map.`);
       }
     } else {
       console.error("Scanned QR data is null or undefined");
       refocusInput(); // Refocus input
       setSearchTermFocus("");
     }
   };

  const handleWarehouseChange = (selectedItem) => {
    setWarehouseValue(selectedItem);
  };

  useEffect(() => {
    if (!searchTerm) {
      setDataProviderSuggestion([]);
    } else {
      const suggestions = [];
      qrCodes.forEach((garment, qrCode, storeCode) => {
        if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
          suggestions.push({ qrCode, garment, storeCode });
        }
      });

      setDataProviderSuggestion(suggestions);
    }
  }, [searchTerm]);

  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes.forEach((garment, qrCode, storeCode) => {
      if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({ qrCode, garment, storeCode });
      }
    });

    const newQrCodes = suggestions.filter(
      (item) => !selectedQrCodesChecked.includes(item.qrCode)
    );

    const updatedSelectedQrCodes = [
      ...selectedQrCodes,
      ...newQrCodes.map((item) => ({
        garmentName: item.garment.garmentName,
        garmentPack: item.garment?.garmentPack || "",
        storeCode: item.garment.storeCode,
        id: item.garment.id,
        rfid: item.garment.rfid,
        qrCode: item.qrCode,
      })),
    ];

    setSelectedQrCodes(updatedSelectedQrCodes);
    setDataProvider(updatedSelectedQrCodes);

    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map((item) => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
  };

  const removeTag = (data) => {
    const updatedTag = selectedQrCodes.filter(
      (item) => item.qrCode !== data.qrCode
    );
    setSelectedQrCodes(updatedTag);
    setDataProvider(updatedTag);
    setSelectedQrCodesChecked(
      selectedQrCodesChecked.filter((code) => code !== data.qrCode)
    );
  };

  const handleRemoveAllSelectedData = () => {
    // Clear all selected QR codes and checked items
    setSelectedQrCodes([]);
    setSearchTerm("");
    setWarehouseValue("");
    setSelectedQrCodesChecked([]);

    // Reset the dataProvider to an empty state
    setDataProvider([]);

    // Optionally, reset the suggestions dataProvider
    setDataProviderSuggestion([]);
  };

  const handleSendToWarehouse = (qrCodeType) => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      const processedData = {
        qrCodeIdList: selectedQrCodes.map(qr => qr.id),
        status: 'PROCESSED',
      };

      const unProcessedData = {
        qrCodeIdList: selectedQrCodes.map(qr => qr.id),
        status: 'UNPROCESSED',
      };

      const dataType = qrCodeType === "PROCESSED" ? processedData : unProcessedData

      if(qrCodeType === "PROCESSED") {
        setIsSendButtonPressedType("PROCESSED")
      } else {
        setIsSendButtonPressedType("UNPROCESSED")
      }

      getReadyGarmentToSendToStore(warehouseId, dataType) // warehouseId
        .then(response => {
          if (!response.data.error) {
            const Res = response.data;


            const message = Res.message;
            const success = Res.status;
            if (success === true) {
              setModalVisible(true);
              setModalStatus('success');
              setModalText(
                'Garment Marked As Ready & Can Be Sent Back To Store',
              );
              setTimeout(() => {
                navigate('/Orders');
              }, 1500);
            } else {
              setModalVisible(true);
              setModalStatus('not Success');
              setModalText(message);
              fetchData(qrCode);
            }
          }
        })
        .catch(err => {
          console.error('Error:', err);
        });
    }
  };

  const rowRenderer = () => {
    return dataProvider?.map((item, index) => (
      <div
        key={index}
        className="flex flex-row py-1 mx-2 justify-content-between"
      >
        <p className="flex-1 text-md font-normal ">{item.qrCode}</p>
        <p className="flex-1 text-md font-normal ">
          {(item.garmentName?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.garmentName + "").length > 20 ? "..." : ""}
        </p>
        <p className="flex-1 text-md font-normal capitalize">
          {(item.storeCode?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item.storeCode + "").length > 20 ? "..." : ""}
        </p>
        <p className="flex-1 text-md font-normal ">
          {(item?.garmentPack?.replace(/_/g, " ") + "").substring(0, 20)}
          {(item?.garmentPack + "").length > 20 ? "..." : ""}
        </p>
        <div
          onClick={() => removeTag(item)}
          className="text-md font-normal text-right cursor-pointer"
        >
          <img
            src={
              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
            }
            style={{ width: "90%" }}
          />
        </div>
      </div>
    ));
  };

  const renderSearchedTagItem = () => {
    return dataProviderSuggestion?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrCode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrCode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-md font-normal ">{item.qrCode}</p>
          <p className="flex-1 text-md font-normal ">
            {(item.garment.garmentName?.replace(/_/g, " ") + "").substring(
              0,
              20
            )}
            {(item.garment.garmentName + "").length > 20 ? "..." : ""}
          </p>
          <p className="flex-1 text-md font-normal capitalize">
            {(item.garment.storeCode?.replace(/_/g, " ") + "").substring(0, 20)}
            {(item.garment.storeCode + "").length > 20 ? "..." : ""}
          </p>
          <p className="flex-1 text-md font-normal ">
            {(item.garment?.garmentPack?.replace(/_/g, " ") + "").substring(
              0,
              20
            )}
            {(item.garment?.garmentPack + "").length > 20 ? "..." : ""}
          </p>

          <div
            className="text-md font-normal text-right"
            style={{ width: "50px", minWidth: "50px" }}
          >
            {isSelected ? (
              <img
                src="Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                style={{ width: 24, height: 24 }}
              />
            ) : (
              <img
                src="Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                style={{ width: 24, height: 24 }}
              />
            )}
          </div>
        </div>
      );
    });
  };

  const handleBackButton = () => {
    navigate("/WarehouseChallanList");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div onClick={() => refocusInput()}>
                <p> </p>
              </div>
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Mark Garment Ready
              </p>
            </div>
            {qrCodes?.size > 0 && (
              <div
                className="flex justify-content-center align-items-center mr-3"
                style={{
                  // left: 28,
                  // position: "absolute",
                  // top: -10,
                  backgroundColor: "red",
                  borderRadius: 20,
                  minWidth: 36,
                  height: 36,
                }}
              >
                <p className=" text-lg text-white font-normal text-center">
                  {qrCodes?.size}
                </p>
              </div>
            )}
            <div
              onClick={() => {
                setSearchMethod(true);
                setQrMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center cursor-pointer"
                style={{
                  height: 32,
                  width: 32,

                  marginRight: 30,
                }}
              >
                <i
                  className="pi pi-search"
                  style={{ fontSize: "27px", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div
              onClick={() => {
                setQrMethod(true);
                setSearchMethod(false);
                setRfidMethod(false);
                refocusInput();
                setSearchTerm("");
                setSearchTermFocus("");
              }}
              className="cursor-pointer"
            >
              <div
                className="flex justify-content-center align-items-center border-1 cursor-pointer"
                style={{
                  height: 32,
                  width: 32,
                  backgroundColor: "#fff",

                  marginRight: 30,
                  borderColor: "#fff",
                }}
              >
                <img
                  src={"images/qr-code.png"}
                  style={{ height: 28, width: 28 }}
                />
              </div>
            </div>
            {enabledRfIdModal && (
              <div
                onClick={() => {
                  setRfidMethod(true);
                  setQrMethod(false);
                  setSearchMethod(false);
                  refocusInput();
                  setSearchTerm("");
                  setSearchTermFocus("");
                }}
                className="cursor-pointer"
              >
                <div
                  className="flex justify-content-center align-items-center cursor-pointer"
                  style={{
                    height: 32,
                    width: 32,
                    marginRight: 30,
                  }}
                >
                  <img
                    src={"images/rfid-tags.png"}
                    style={{ height: 38, width: 38 }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex-1 flex flex-column justify-content-center align-items-center">
          <ProgressSpinner />

          <p
            style={{
              color: "#000",
              fontSize: 20,
              fontWeight: "700",
              alignSelf: "center",
            }}
          >
            Garment List is Loading...
          </p>
        </div>
      ) : (
        <div className="flex flex-1 ">
          <div className="flex-1">
            {!loading && (
              <div className="flex-1">
                {qrMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => {
                            setSearchTermFocus(e.target.value);
                            handleScan({ data: e.target.value });
                          }}
                          placeholder="Scan QR Code"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {enabledRfIdModal && rfidMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl"></InputIcon>
                        <InputText
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                          ref={inputRef}
                          value={searchTermFocus}
                          onChange={(e) => {
                            setSearchTermFocus(e.target.value);
                            handleScanRFID({ data: e.target.value });
                          }}
                          placeholder="Scan RFID Tag"
                          showSoftInputOnFocus={false}
                          autoFocus={true}
                        />
                      </IconField>
                    </div>
                    {searchTermFocus && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={() => handleClearSearch()}
                      >
                        <p
                          className="text-3xl font-bold ml-4"
                          style={{ color: "red" }}
                        >
                          X
                        </p>
                      </div>
                    )}
                  </div>
                )}
                {searchMethod && (
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <div className=" flex flex-1">
                      <IconField iconPosition="left" className="flex flex-1">
                        <InputIcon className="pi pi-search text-xl">
                          {" "}
                        </InputIcon>
                        <InputText
                          placeholder="Search Invoice No."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          className="text-xl flex flex-1 py-1 px-5"
                          style={{ borderRadius: 30 }}
                        />
                      </IconField>
                    </div>
                    {dataProviderSuggestion?.length > 0 && (
                      <div
                        className="flex justify-content-center align-items-center cursor-pointer"
                        onClick={handleSelectAllSearchedData}
                      >
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Add.png"
                          }
                          style={{ width: "50%" }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p
                    className="flex-1 text-2xl font-medium text-center"
                    style={{ color: "green" }}
                  >
                    {alreadyPresentData}
                  </p>
                </div>
                {qrMethod || rfidMethod ? (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Scan Tag
                    </p>
                  </div>
                ) : dataProviderSuggestion?.length !== 0 ? (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-xl font-medium ">Tag</p>
                      <p className="flex-1 text-xl font-medium">Garment</p>
                      <p className="flex-1 text-xl font-medium">Store</p>
                      <p className="flex-1 text-xl font-medium">Packing</p>

                      <p className="text-xl font-medium text-right">
                        Add
                      </p>
                    </div>
                    <div style={{ overflowY: "auto", height: "75vh" }}>
                      {renderSearchedTagItem()}
                    </div>
                  </div>
                ) : (
                  <div className="my-3">
                    <p className=" text-3xl  font-bold text-center">
                      Please Search Tag
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
          <div
            className=" flex-1 surface-0"
            style={{
              "--surface-0": "#f2f2f2",
            }}
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Selected Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "10%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                {selectedQrCodes.length === 0 ? (
                  <div>
                    <p className=" text-3xl  font-bold text-center">
                      Please Select Tag
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-xl font-medium ">Tag</p>
                      <p className="flex-1 text-xl font-medium">Garment</p>
                      <p className="flex-1 text-xl font-medium">Store</p>
                      <p className="flex-1 text-xl font-medium">Packing</p>

                      <p className="text-xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      <div style={{ overflowY: "auto", height: "65vh" }}>
                        {rowRenderer()}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            <div className="flex">
              {selectedQrCodes.length > 0 && (
                <div
                  className="flex-1 my-1 mx-2"
                  style={{
                    pointerEvents: isSendButtonPressed ? "none" : "auto",
                  }}
                >
                  <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                    <div className=" flex justify-content-center">
                      <Button
                        onClick={() => handleSendToWarehouse("PROCESSED")}
                        disabled={isSendButtonPressed}
                        className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                      >
                        <p className="text-xl font-bold text-white text-center">
                          {isSendButtonPressedType === "PROCESSED"
                            ? "Processing..."
                            : "Process"}
                        </p>

                        <div className="flex justify-content-center ml-5 relative">
                          <img
                            src={
                              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                            }
                            style={{ width: 30 }}
                          />
                          <div
                            style={{
                              left: 28,
                              position: "absolute",
                              top: -10,
                              backgroundColor: "red",
                              borderRadius: 20,
                              minWidth: 36,
                              height: 36,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <p className=" text-md  font-normal text-center">
                              {selectedQrCodes.length}
                            </p>
                          </div>
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {selectedQrCodes.length > 0 && (
                <div
                  className="flex-1 my-1 mx-2"
                  style={{
                    pointerEvents: isSendButtonPressed ? "none" : "auto",
                  }}
                >
                  <div className="flex-1 mx-2 mb-1 mt-2 sticky z-2 bottom-0">
                    <div className=" flex justify-content-center">
                      <Button
                        onClick={() => handleSendToWarehouse("UNPROCESSED")}
                        disabled={isSendButtonPressed}
                        className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                      >
                        <p className="text-xl font-bold text-white text-center">
                          {isSendButtonPressedType === "UNPROCESSED"
                            ? "UnProcessing..."
                            : "UnProcess"}
                        </p>

                        <div className="flex justify-content-center ml-5 relative">
                          <img
                            src={
                              "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                            }
                            style={{ width: 30 }}
                          />
                          <div
                            style={{
                              left: 28,
                              position: "absolute",
                              top: -10,
                              backgroundColor: "red",
                              borderRadius: 20,
                              minWidth: 36,
                              height: 36,
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <p className=" text-md  font-normal text-center">
                              {selectedQrCodes.length}
                            </p>
                          </div>
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WarehouseOrderProcess;
